module.exports = __webpack_public_path__ + "static/media/Quotenewchange.22313beb.png";